import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { PayrollComponent } from 'app/dialogs/payroll/payroll.component';
import { AuthService } from 'app/services/auth.service';
import { PayrollService } from 'app/services/models/payroll.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-payroll-list',
  templateUrl: './payroll-list.component.html',
  styleUrls: ['./payroll-list.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class PayrollListComponent implements OnInit {
  @Input() personId: number;
  constructor(
    private payrollService: PayrollService,
    private modalService: NgbModal,
    public authService:AuthService
  ) { }

  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  public searchValue = '';
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;

  async ngOnInit() {
    this.payrollService.event$.subscribe(async result=>{
    await this.getAllPayrollList(this.pageBasic - 1, this.selectedSize, this.searchValue, this.personId);

    })
    await this.getAllPayrollList(this.pageBasic - 1, this.selectedSize, this.searchValue, this.personId);
  }

  async getAllPayrollList(page, size, search, personId) {
    this.blockUI.start("Personeller yükleniyor..");
    const payrolAuthoriaziton = this.authService.isEndpointStatus('GET.Reading.GetAllByPersonIdPayroll');
    if(payrolAuthoriaziton){
      const data = await this.payrollService.getAllPayrollByIdPersonList(page, size, search, personId);
      console.log(data);
      this.rows = data.payrolls;
      this.totalCount = data.totalCount;  
    }
    this.blockUI.stop();
  }

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.searchValue = val;
    setTimeout(async () => {

      await this.getAllPayrollList(this.pageBasic - 1, this.selectedSize, this.searchValue, this.personId);
    }, 500);
  }

  async onPageChange(pageNumber: number) {
    await this.getAllPayrollList(this.pageBasic - 1, this.selectedSize, this.searchValue, this.personId);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllPayrollList(this.pageBasic - 1, this.selectedSize, this.searchValue, this.personId);
  }

  createPayroll() {
    const modal = this.modalService.open(PayrollComponent, {
      size: 'sm',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      personId:this.personId,
      row:null
    };
  }

  updatePayroll(row) {
    const modal = this.modalService.open(PayrollComponent, {
      size: 'sm',
      centered: true,
      windowClass: 'modal modal-success'
    });
    modal.componentInstance.data = {
      personId: this.personId,
      row:row
    };
  }

}
